import { useAdminResourceCheckStore } from '~~/layers/crane-manager/admin-stores/adminResourceCheck.store'

/**
 * Named route middleware: guards dynamic `/crane-manager/:resource/*` by enabled registry + role.
 *
 * Uses `GET /api/crane-manager/resource-check/:resource` (small O(1) response) instead of loading the
 * full resource list from `GET /api/crane-manager/resources`. Successful checks are cached per session in
 * `useAdminResourceCheckStore` so repeat navigations to the same resource skip the round trip.
 *
 * Why: failed checks (unknown/disabled resource or insufficient role) should land at `/crane-manager/login`
 * as the unified admin access entry point, with redirect context preserved.
 *
 * Same-origin `$fetch` only — never `useApiBaseUrl()` / designerBaseUrl (host gate refuses
 * `/api/crane-manager` on the customer designer host).
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const resource = String(to.params.resource ?? '').trim()
    if (!resource) {
        return
    }

    const checkStore = useAdminResourceCheckStore()
    try {
        await checkStore.ensureResourceAllowed(resource, {})
    } catch {
        return navigateTo(
            {
                path: '/crane-manager/login',
                query: {
                    redirect: to.fullPath,
                    reason: 'forbidden',
                },
            },
            { replace: true }
        )
    }
})
